<div class="btn-group d-block">
  <button class="btn btn-primary popover-wrap-2" (click)="onAction1($event)" title="Edit"><i class="fa fa-edit"></i><div class="popover-content top">Edit</div></button>
  <button class="btn btn-danger popover-wrap-2" (click)="onAction2($event)" title="Delete"><i class="fa fa-trash"></i><div class="popover-content top">Delete</div></button>
  </div>